<template>
  <div>
    <Card>
      <Card dis-hover :bordered="false" :padding="0">
        <span>设备总数：{{ deviceCount }}，在线设备数：{{ onDeviceList.length }}</span>
        <Button icon="md-refresh" shape="circle" title="刷新" :loading="btnLoading" @click="refreshAll"
                style="margin-left: 10px"></Button>
        <Button type="primary" style="margin-left: 10px" @click="gotoDeviceList">监控设备列表</Button>
      </Card>
      <Divider></Divider>
      <div style="width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;margin-top: 10px;">
        <div v-for="(item,index) in videoHlsUrls" :key="index" style="width:48%;margin-right: 10px;margin-top: 10px">
          <div>
            <!--            <Button @click="controlVideo('UP',item.deviceCode)">上</Button>-->
            <!--            <Button @click="controlVideo('DOWN',item.deviceCode)">下</Button>-->
            <!--            <Button @click="controlVideo('LEFT',item.deviceCode)">左</Button>-->
            <!--            <Button @click="controlVideo('RIGHT',item.deviceCode)">右</Button>-->
            <!--            <Button @click="controlVideo('LEFT_UP',item.deviceCode)">左上</Button>-->
            <!--            <Button @click="controlVideo('LEFT_DOWN',item.deviceCode)">左下</Button>-->
            <!--            <Button @click="controlVideo('RIGHT_UP',item.deviceCode)">右上</Button>-->
            <!--            <Button @click="controlVideo('RIGHT_DOWN',item.deviceCode)">右下</Button>-->
            <!--            <Button @click="controlVideo('IRIS_ENLARGE',item.deviceCode)">扩大</Button>-->
            <!--            <Button @click="controlVideo('IRIS_REDUCE',item.deviceCode)">缩小</Button>-->
          </div>
          <VideoComp :v-data="item"></VideoComp>
        </div>
      </div>
      <!--      <Page style="text-align: right;margin-top: 10px"-->
      <!--            show-sizer-->
      <!--            show-total-->
      <!--            transfer-->
      <!--            :total="dataTotal"-->
      <!--            :page-size="pageSize"-->
      <!--            :page-size-opts="pageSizeOpts"-->
      <!--            :current-page="currentPage"-->
      <!--            @on-change="pageChange"-->
      <!--            @on-page-size-change="pageSizeChange"-->
      <!--      ></Page>-->
    </Card>
    <!--    <Button type="primary" @click="getToken">跳转获取Code</Button>-->
    <!--    <div>ssoUrl: {{ loginUrl }}</div>-->
    <!--    &lt;!&ndash;    <Button type="primary" @click="getCode">iframe获取Code</Button>&ndash;&gt;-->
    <!--    <div>authCode: {{ authCode }}</div>-->
    <!--    <div>byCodeResult: {{ byCodeResult }}</div>-->
    <!--    <div>token: {{ accessToken }}</div>-->
    <!--    <Button type="primary" @click="getVideoList">获取list</Button>-->
    <!--    <div>{{ videoList }}</div>-->
    <!--    <Button type="primary" @click="getVideo">视频流</Button>-->
    <!--    <div>{{ videoHlsUrl }}</div>-->
    <!--    &lt;!&ndash;    <iframe ref="tyslLoginFrame" :src="videoHlsUrl" :frameborder="0" style="height: 800px;width: 100%"></iframe>&ndash;&gt;-->
    <!--    <Button type="primary" @click="playVideo">播放</Button>-->
    <!--    &lt;!&ndash;    <Button type="primary" @click="getMyVideoList">获取我的设备</Button>&ndash;&gt;-->
    <!--    &lt;!&ndash;    <div>{{ myList }}</div>&ndash;&gt;-->
  </div>
</template>

<script>
import VideoComp from '@/views/TianyiVideo/components/VideoComp.vue'

export default {
  name: "TianyiVideo",
  components: {
    VideoComp
  },
  data() {
    return {
      btnLoading: false,
      regionId: '',
      regionmId: '',
      loginUrl: '',
      accessToken: '',
      tokenExpireTime: null,
      byCodeResult: null,
      cbUrl: '',
      authCode: null,
      theRequest: {},
      videoList: [],
      deviceList: [],
      onDeviceList: [],
      local: '',
      deviceCount: 0,
      onlineCount: 0,
      videoHlsUrls: [],
      vData: null,
      dataTotal: 0,
      pageSize: 50,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  mounted() {
    this.setTimeToRefresh()
    this.getToken()
    // this.getVideoList()
    // this.getRequestCode()
  },
  methods: {
    setTimeToRefresh() {
      setTimeout(() => {
        if (this.$moment().format('YYYY-MM-DD HH:mm:ss') === this.$moment(this.tokenExpireTime).format('YYYY-MM-DD HH:mm:ss')) {
          this.getToken()
        }
      }, 60000)
    },
    playVideo() {
      this.$nextTick(() => {
        this.vData = {
          hlsurl: this.videoHlsUrl, //视频url地址
          cameraId: 'fid0' //id
        }
        // this.$refs.jessibuca.play()
      })
    },
    gotoDeviceList() {
      this.$router.push({
        name: 'deviceList',
        query: {
          regionId: this.regionmId
        }
      })
    },
    getToken() {
      this.$http.get(`/api/tysl/getToken`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.accessToken = res.data.data.accessToken
          this.tokenExpireTime = res.data.data.accessTokenExpireTime
          if (this.accessToken === null) {
            this.loginUrl = res.data.data.loginUrl
            window.open(this.loginUrl, '_self')
            // window.open(this.loginUrl)
          } else {
            localStorage.setItem('tyToken', this.accessToken)
            this.getRequestCode()
          }
        }
      })
    },
    getRequestCode() {
      // this.local = "http://219.146.4.90:8080/tianyi/TianyiVideo?authCode=aBFIll9wQoSx1hiQFB99YpGs&errorCode=0"
      // var url = this.local
      this.local = window.location
      var url = this.local.hash
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          this.theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      if (this.theRequest.authCode) {
        this.authCode = this.theRequest.authCode
        this.getTokenByCode()
      } else {
        this.getDeviceCount()
        this.getVideoList()
      }
      // console.log(this.authCode)
    },
    ///api/tysl/getTokenByCode？code=
    getTokenByCode() {
      this.$http.get(`/api/tysl/getTokenByCode?code=${this.authCode}`).then(res => {
        // console.log(res)
        this.byCodeResult = res
        if (res.data.status === '200') {
          this.accessToken = res.data.data.accessToken
          localStorage.setItem('tyToken', this.accessToken)
          this.getDeviceCount()
          this.getVideoList()
        }
      })
    },
    getVideoList() {
      this.$http.get(`/api/tysl/getReginWithGroupList?accessToken=${this.accessToken}&regionId=${this.regionId}`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.videoList = res.data.data
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].name === '移动设备') {
              this.regionmId = res.data.data[i].id
              this.getDeviceList()
            }
          }
        }
      })
    },
    getDeviceCount() {
      this.$http.get(`/api/tysl/getCusTreeDeviceCount?accessToken=${this.accessToken}&isClearCache=0`).then(res => {
        // console.log(res)
        if (res.data.status === '200' && res.data.data != null) {
          this.deviceCount = res.data.data.deviceCount
          this.onlineCount = res.data.data.onlineCount
        }
        this.btnLoading = false
      })
    },
    refreshAll() {
      this.btnLoading = true
      this.getDeviceCount()
      this.getVideoList()
    },
    getDeviceList() {
      this.$http.get(`/api/tysl/getDeviceList?accessToken=${this.accessToken}&regionId=${this.regionmId}&pageNo=${this.currentPage}&&pageSize=${this.pageSize}`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.deviceList = res.data.data.list
          this.getBatchDeviceStatus()
        }
      })
    },
    //获取在线设备/api/tysl/batchDeviceStatus
    getBatchDeviceStatus() {
      let deviceCodes = this.deviceList.map(item => item.deviceCode).toString()
      this.$http.get(`/api/tysl/batchDeviceStatus?accessToken=${this.accessToken}&deviceCodes=${deviceCodes}`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.onDeviceList = res.data.data.filter(item => item.status == 1)
          this.dataTotal = this.onDeviceList.length
          this.getVideoHls()
        }
      })
    },
    getVideoHls() {
      if (this.onDeviceList.length === 0) return
      for (var i = 0; i < this.onDeviceList.length; i++) {
        this.getHls(this.onDeviceList[i].deviceCode, i)
      }
    },
    getHls(deviceCode, index) {
      this.videoHlsUrls = []
      this.$http.get(`/api/tysl/getDeviceMediaUrlHls?accessToken=${this.accessToken}&deviceCode=${deviceCode}`).then(res => {
        if (res.data.status === '200') {
          const ob = JSON.parse(res.data.data)
          ob.url = ob.url.replace('liveplay.vaas.cn-qingdao-1.ctyunxs.cn', 'dzgllw.com')
          this.videoHlsUrls.push({
            hlsurl: ob.url, //视频url地址
            cameraId: 'fid' + index, //id
            deviceCode: deviceCode
          })
        }
      })
    },
    controlVideo(ptzCmd, deviceCode) {
      //开始
      let action = 0
      this.$http.post(`/api/tysl/deviceControl`, {
        accessToken: this.accessToken,
        deviceCode: deviceCode,
        action: action,
        ptzCmd: ptzCmd,
        speed: 100
      }).then(res => {
        console.log(0)
        if (res.data.status === '200') {
          // 停止
          action = 1
          this.$http.post(`/api/tysl/deviceControl`, {
            accessToken: this.accessToken,
            deviceCode: deviceCode,
            action: action,
            ptzCmd: ptzCmd,
            speed: 100
          }).then(res => {
            console.log(1)
            if (res.data.status === '200') {
            }
          })
        }
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getDeviceList()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getDeviceList()
    }
  }
}
</script>

<style scoped lang="less">

.video {
  position: absolute;
  width: 100%;
  height: 100%;
  //height: 15vh;
  top: 0;
  left: 0;
}

</style>
